// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  google_analytics_code: 'UA-120566748-1'
};

export const urls = {
  apiBase: 'https://paguela-api.prd.g.actuar.cloud',
  apiBaseV2: 'https://paguela-api.prd.g.actuar.cloud',
  apiBaseActuar: 'https://api.actuar.com',
  identity: 'https://identity-api.actuar.cloud',
  shortener: 'https://link.pague.la',
  clientNotification: 'https://clientnotification-api.actuar.cloud',
  notaFiscalBase: 'http://www2.goiania.go.gov.br/sistemas/snfse/asp/snfse00200w0.asp',
  user_service: 'https://userservice-api.actuar.cloud'
};

export const strings = {
  clientId: 'PagueLaWeb',
  pagueLaAccount: '44cc6127-5197-401d-a68d-3bc9a2f4fe3e',
  sentry: 'https://ba9f2e71bcd9489791d2782d8a015742@sentry.io/1235169'
};

export const adquirenteStrings = {
  nome: 'Cielo',
  meioPagamento: '',
  tipoMeioPagamento: 'CreditCard'
};

export const contaStrings = {
  contaId: '6f493c93-bf5d-43c7-96d1-55f06a37601d'
};

export const braspag = {
  providerMerchantId: 'c7f999ad-0ea4-4621-9fd6-6b3d475c5d70',
  providerOrgId: '1snn5n9w'
};

export const CONTAS = {
  PAGUELA_ADMIN: '2b631bdc-c866-4d48-ac00-e2f54703a919',
  ACTUAR_CONTAID: '95a38624-54bd-4042-8b4e-bfcc3096fb08',
  TOLETUS_CONTAID: 'bd4a4597-a3e0-4da2-b058-682160e6d7f7',
  PAGUELA_CONTAID: '6f493c93-bf5d-43c7-96d1-55f06a37601d'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts